import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WaistCircumferenceLogPage = lazy(
  () => import("./WaistCircumferenceLogPage"),
);

const WaistCircumferenceLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WaistCircumferenceLogPage />
    </Suspense>
  );
};

export default WaistCircumferenceLogPageLazy;
